import DIApi from './_diApi';

class AccountingObjectCategoryAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'AccountingObjectCategorys';
}

export default new AccountingObjectCategoryAPI();
